var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13607 3.56055C8.96548 3.56055 8.79471 3.62683 8.66471 3.75716L8.60742 3.81445C8.34676 4.07512 8.34676 4.49716 8.60742 4.75716L11.1829 7.33268H2.4694C2.1014 7.33268 1.80273 7.63135 1.80273 7.99935C1.80273 8.36735 2.1014 8.66602 2.4694 8.66602H11.1829L8.60742 11.2415C8.34676 11.5022 8.34676 11.9242 8.60742 12.1842L8.66471 12.2415C8.92538 12.5022 9.34742 12.5022 9.60742 12.2415L13.3783 8.4707C13.6389 8.21004 13.6389 7.78799 13.3783 7.52799L9.60742 3.75716C9.47709 3.62683 9.30665 3.56055 9.13607 3.56055Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.8d0e142e7815e3b862948d2c8066eba4.svg";
export { ForwardRef as ReactComponent };